<div class="back-button-container">
  <a [routerLink]="link" class="back-button-link">
    <mat-icon class="back-button-icon" fontSet="material-symbols-outlined"
      >expand_circle_down
    </mat-icon>
    <span class="back-button-text">Back</span>
  </a>
</div>
